// Trim all string object properties
export const trimObjectStrings = obj =>
  Object.keys(obj).reduce((acc, key) => {
    const value = typeof obj[key] === 'string' ? obj[key].trim() : obj[key];
    return { ...acc, [key]: value };
  }, {});
